import * as React from 'react';
import { SVGProps } from 'react';

const IconCameraSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.862 2.276A.5.5 0 0 1 6.309 2h3.382a.5.5 0 0 1 .447.276L10.5 3H14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3.5l.362-.724zM4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"
    />
  </svg>
);
export default IconCameraSizeS;
